import qs from "query-string"
import { setterAction } from "../common/redux"
import Source from "../interview/Source"
import * as t from "./actionTypes"
import * as interviewActions from "../interview/actions"

export const getCustomSuccess = setterAction(t.GET_CUSTOM_SUCCESS)
export const setTheme = setterAction(t.SET_THEME)
export const getBrandSuccess = setterAction(t.GET_BRAND_SUCCESS)
export const updateBrandGating = setterAction(t.UPDATE_BRAND_GATING)
export const setTermsAgreed = setterAction(t.SET_TERMS_AGREED)

export const getCustom = () => dispatch => {
  const query = qs.parse(window.location.search)
  const symptom = query.symptom
  Source.customVisit(symptom)
    .then(data => {
      if (query.question && query.response) {
        dispatch(
          getCustomSuccess({
            ...data,
            question: query.question,
            response: query.response,
          })
        )
      } else {
        dispatch(getCustomSuccess(data))
      }
    })
    .catch(error => {
      if (error.response && error.response.status === 404) {
        dispatch(getCustomSuccess({ symptom: query.symptom }))
      } else {
        dispatch(interviewActions.genericError(error))
      }
    })
}

export const getBrand = (brand=undefined, token=null) => dispatch => {
  if (!brand) {
    brand = "public"
  }
  if (window.location.pathname.startsWith("/demo") ) {
    brand = "demo"
  }

  return Source.brand(token ? 'token' : 'name', token ? token : brand)
    .then(data => {
      dispatch(getBrandSuccess(data))
      return Promise.resolve()
    })
    .catch(error => {
      return Promise.resolve()
    })
}



// WEBPACK FOOTER //
// ./assets/embed/actions.js